export { default } from './QuickViewSubstanceModal'
